export default __webpack_public_path__ + "static/media/boy7.cb0e6337.jpg";